module.exports = __webpack_public_path__ + "media/images/new-project-1750abb107e136bc8e0dbf914adb67c2.png";